<template>
  <div id="app">
    <!-- 1.视图切换标签 -->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "App", // 1.appName

  data() {
    // 2.datas
    return {
      clearTimer: null, // 2.1.定时器对象
      loginTimer: null, // 2.2.登录状态定时器对象
      loginTimer2: null,
    };
  },

  methods: {
    // 3.mounted
    // parseWindowChange(){                                                    // 3.1.检测窗口尺寸重新刷新页面
    //   window.onresize = () => {
    //     clearTimeout(this.clearTimer);
    //     this.clearTimer = setTimeout(() => {
    //       this.$router.go(0);
    //     }, 500);
    //   }
    // },

    checkLoginStatus() {
      // 3.2.检测用户登录状态
      let loginStatus = localStorage.loginStatus || 0;
      this.loginTimer = setInterval(() => {
        if (loginStatus) {
          return false;
        }

        this.$message.error("当前登录状态错误，请重新登录");

        setTimeout(() => {
          localStorage.removeItem("loginStatus");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.$router.push("/login");
        }, 600);
      }, 60000);
    },
  },

  mounted() {
    // 4.mounted
    //this.parseWindowChange();
    if (localStorage.baseInfo) {
      window.document.title =
        JSON.parse(localStorage.baseInfo).web_title || "代发系统";
    }
    this.loginTimer2 = setInterval(() => {
      let sysId = "";
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        let userInfo = JSON.parse(localStorage.userInfo);
        sysId = userInfo.customerId;
      }
      let token = "";
      if (localStorage.token) {
        token = localStorage.token;
      }
      let data = {
        sysId: sysId,
        code: token,
      };
      if (sysId != "") {
        this.getCustomerInfoRequest(data).then((res) => {
          if (res) {
            console.log(res);
            if (res.code == 201) {
              this.$message({
                type: "info",
                message: res.msg,
                duration: 6000,
              });
              setTimeout(() => {
                if (localStorage.loginStatus) {
                  localStorage.removeItem("loginStatus");
                }
                if (localStorage.token) {
                  localStorage.removeItem("token");
                }
                if (localStorage.token) {
                  localStorage.removeItem("userInfo");
                }
                this.$router.push("/login");

                clearInterval(this.loginTimer2);
              }, 3000);
            }
          }
        });
      }
    }, 10000);
  },

  destroyed() {
    // 5.destroyed
    clearInterval(this.loginTimer);
  },
};
</script>

<style lang="scss">
// @import "./public/css/public.css";
@import "./public/css/public.scss";
</style>
